/**
 * Reverose — Préchargement de la 2e image des cartes produit (survol).
 *
 * Le thème ne précharge l'image de survol que pour les cartes dans un carrousel
 * (product-card.js, #preloadNextPreviewImage, si slideshow.isNested). Dans une grille,
 * elle reste en loading="lazy" et ne se charge qu'au survol : blanc d'environ une demi-seconde.
 *
 * Ici : quand la carte approche de l'écran, l'image suivant la première diapositive visible
 * passe en chargement normal, priorité basse. Seulement sur les appareils avec souris
 * (le survol n'existe pas au doigt). Rendu dans blocks/_product-card-gallery.liquid (RV-CUSTOM).
 */
const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

/** @type {IntersectionObserver | null} */
let observer = null;

function getObserver() {
  observer ??= new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer?.unobserve(entry.target);
        preload(entry.target);
      }
    },
    { rootMargin: '200px 0px' }
  );
  return observer;
}

/** @param {Element} gallery */
function preload(gallery) {
  const slides = gallery.querySelectorAll('slideshow-slide:not([hidden])');
  const image = slides[1]?.querySelector('img[loading="lazy"]');
  if (!(image instanceof HTMLImageElement)) return;

  image.fetchPriority = 'low';
  image.removeAttribute('loading');
}

class RvCardHoverPreload extends HTMLElement {
  /** @type {Element | null} */
  #gallery = null;

  connectedCallback() {
    if (!canHover.matches) return;

    this.#gallery = this.closest('.card-gallery');
    if (this.#gallery) getObserver().observe(this.#gallery);
  }

  disconnectedCallback() {
    if (this.#gallery) observer?.unobserve(this.#gallery);
    this.#gallery = null;
  }
}

if (!customElements.get('rv-card-hover-preload')) {
  customElements.define('rv-card-hover-preload', RvCardHoverPreload);
}
